import Http from '@/api/http2.js'
import baseURL from "@/api/baseURL"
/*
   [ 元数据管理模块 数据源管理 ]
*/

const dataSourceMgr = {

}

// const VOLUNTEER_API = "http://192.168.1.118:8088";
const VOLUNTEER_API =baseURL;
// const VOLUNTEER_API = 'http://www.hk952183.com:44808';
// const VOLUNTEER_API = "https://cloud.zyz.hk952183.com:8050";

/*
   [ 元数据管理模块 元数据管理  ]
*/

const metaDataMgrDao = {
/*
* 政府援助服务工单
*/
  //  验证码
  getcode: function (params) {
    url: "/jjyl/sys/auth/checkCode";
    params = params || {};
    return Http.post(url, params);
  },
  getMapCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/findMapCustomer";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapCustomerAndOrder: function (params) {
    url: "/jjyl/WebCustomer/info/findMapCustomerAndOrder";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  getMapServiceStation: function (params) {
    url: "/jjyl/WebServestation/info/findMapServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapServepersonAndServestation: function (params) {
    url: "/jjyl/WebServeperson/info/findMapServepersonAndServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapServepersonAndCustomer: function (params) {
    url: "/jjyl/WebServeperson/info/findMapServepersonAndServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertCustomerReturnVisit: function (params) {
    url: "/jjyl/WebCustomer/info/insertCustomerReturnVisit";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/findMapServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServepersonNumbers: function (params) {
    url: "/jjyl/WebServeperson/info/findServepersonNumbers";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapInstitutions: function (params) {
    url: "/jjyl/institutions/info/findAllMapInstitutions";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapCommunitys: function (params) {
    url: "/jjyl/communitys/info/findMapCommunitys";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapSummary: function (params) {
    url: "/jjyl/communitys/info/findMapSummary";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServicePgdNumbers: function (params) {
    url: "/jjyl/servicePgd/info/findServicePgdStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  findReportData: function (params) {
    url: "/jjyl/servicePgd/info/findReportData";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServicePgdStatesList: function (params) {
    url: "/jjyl/servicePgd/info/findServicePgdStatesList";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServicePgdStatesNumbers: function (params) {
    url: "/jjyl/servicePgd/info/findServicePgdStatesNumbers";
    params = params || {};
    return Http.listPost(url, params);
  },
  //已完成工单编辑
  UpdateOrderpgd: function (params) {
    url: "/jjyl/servicePgd/info/UpdateOrderpgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  getSHBLocationByPhone: function (params) {
    url: "/jjyl/WebCustomer/info/getSHBLocationByPhone";
    params = params || {};
    return Http.listPost(url, params);
  },
  getCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomer";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  callsummaryByCustomerPhone: function (params) {
    let url = "jjyl/callInfo/info/callsummaryByCustomerPhone";
    params = params || {};
    return Http.listPost(url, params);
  },
  callSellfRecord: function (params) {
    let url = "jjyl/callInfo/info/callSellfRecord";
    params = params || {};
    return Http.listPost(url, params);
  },
  getDelCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/findDelCustomer";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 信息回访工单请求
  getdatalist: function (params) {
    url: "/jjyl/servicePgd/info/findEvaluatepgd";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 工单评价系统评价请求
  SubmitEvaluationRequest: function (params) {
    url: "/jjyl/servicePgd/info/updateEvaluatepgd";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 工单评价系统查看请求
  Submitseelist: function (params) {
    url: "/jjyl/servicePgd/info/findEvaluatepgdById";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 系统公告页面获取表格数据请求
  getSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/findSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 系统公告页面添加数据请求
  addSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/insertSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 系统公告页面修改数据请求
  amendSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/updateSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 系统公告页面发布数据请求
  publishSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/relasSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 系统公告页面删除数据请求
  deleteSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/deleteSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 系统公告页面搜索数据请求
  searchSystemNotice: function (params) {
    url: "/jjyl/sysnotice/info/findSysnotice";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 首页左上角的图表请求
  workRecordrequest: function (params) {
    url: "/jjyl/servicePgd/info/findPgdbymonthtime";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 工单评价系统搜索请求
  Submisearchlist: function (params) {
    url: "/jjyl/servicePgd/info/customerName";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 消息通知
  // 消息通知-全查
  messageGetAll: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanage";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 消息通知-搜索
  messageSearch: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanageById";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 消息通知-新增
  messageAdd: function (params) {
    url: "/jjyl/messagemanage/info/insertMessagemanage";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 消息通知-修改
  messageAmend: function (params) {
    url: "/jjyl/messagemanage/info/updateMessagemanage";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 消息通知-删除
  messageDelete: function (params) {
    url: "/jjyl/messagemanage/info/deleteMessagemanage";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 消息通知-消息总数
  messageGetNumb: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanageCount";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 服务对象统计表-获取表格
  getServiceTargetStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findCustomerStatisticas";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 服务对象统计表-导出表格
  downloadServiceTargetStatistics: function (params) {
    url: "/jjyl/statisticalData/info/downloadCustomerStatistica";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.excelPost(url, params);
  },

  // 沭阳新增统计报表
  // 获取表格数据
  SYServestationStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findServestationStatistics";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 导出表格
  SYexportServestationStatistics: function (params) {
    url: "/jjyl/statisticalData/info/exportServestationStatistics";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.excelPost(url, params);
  },
  // 导出表格1 191117
  getOldAgePension: function (params) {
    url: "/jjyl/subsidyStatistics/info/exportSubsidyStatistics";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.excelPost(url, params);
  },
  // 导出表格2191117OldAgePension
  getServiceSubsidies: function (params) {
    url: "/jjyl/subsidy/info/exportSubsidy";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.excelPost(url, params);
  },
  // 获取饼状图数据
  SYServestationPersonStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findServestationPersonStatistics";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 获取柱状图数据
  SYServestationCustomerStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findServestationCustomerStatistics";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 全查
  SYfindSubordinate: function (params) {
    url: "/jjyl/subordinate/info/findSubordinate";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 新增
  SYinsertSubordinate: function (params) {
    url: "/jjyl/subordinate/info/insertSubordinate";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 修改
  SYupdateSubordinate: function (params) {
    url: "/jjyl/subordinate/info/updateSubordinate";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 删除
  SYdeleteSubordinate: function (params) {
    url: "/jjyl/subordinate/info/deleteSubordinate";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },


  // downloadServiceTargetStatistics: function (params) {
  //   url: "/jjyl/statisticalData/info/downloadCustomerStatistica";
  //   //url: "/jjyl/employee/basic//basicdata";
  //   params = params || {};
  //   return Http.excelPost(url, params);
  // },

  // 健康数据类别管理
  findHealthdata: function (params) {
    url: "/jjyl/healthdata/info/findHealthdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  findHealthDataById: function (params) {
    url: "/jjyl/healthdata/info/findHealthDataById";
    params = params || {};
    return Http.listPost(url, params);
  },
  addHealthData: function (params) {
    url: "/jjyl/healthdata/info/insertHealthdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  amendHealthData: function (params) {
    url: "/jjyl/healthdata/info/updateHealthdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteHealthData: function (params) {
    url: "/jjyl/healthdata/info/deleteHealthdata";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 月度服务工时统计
  getServiceHoursData: function (params) {
    url: "/jjyl/statisticalData/info/findServepersonWorkinghours";
    params = params || {};
    return Http.listPost(url, params);
  },
  // ※时间段内服务覆盖老人数与线下服务老人数比值
  getTimePeriodService: function (params) {
    url: "/jjyl/statisticalData/info/findCustomerRatio";
    params = params || {};
    return Http.listPost(url, params);
  },
  //首页人数数据统计
  getfindCustomerAmount: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerAmount";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 沭阳老人信息与地图
  getfuwuzhan: function (params) {
    url: "/jjyl/WebServestation/info/findServestationById";
    params = params || {};
    return Http.listPost(url, params);
  },
  getfuwuren1: function (params) {
    url: "/jjyl/WebServeperson/info/findServepersonPoint";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 表格1
  getfindCallInfoStatics: function (params) {
    let url = "jjyl/callInfo/info/findCallInfoStatics";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 表格1
  getfindSubsidyStatistics: function (params) {
    url: "/jjyl/subsidyStatistics/info/findSubsidyStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },

  // 表格2
  getfindSubsidyobjectStatisticsService: function (params) {
    url: "/jjyl/subsidy/info/findSubsidy";
    params = params || {};
    return Http.listPost(url, params);
  },



  getfuwuduixiang: function (params) {
    url: "/jjyl/WebCustomer/info/getCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },
  getfuwuren2: function (params) {
    url: "/jjyl/WebServeperson/info/findServepersonCusotmerPoint";
    params = params || {};
    return Http.listPost(url, params);
  },

  getCustomersStates: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  getCustomersTypes: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerType";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServerStation: function (params) {
    url: "/jjyl/WebCustomer/info/findServerStation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCustomerHealthy: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerHealthy";
    params = params || {};
    return Http.listPost(url, params);
  },

  findFilialPiety: function (params) {
    url: "/jjyl/iotactivitylog/info/findActivitylog";
    params = params || {};
    return Http.listPost(url, params);
  },

  findCustomerHealthXCX: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerHealthXCX";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCustomerServicePgdStatistics: function (params) {
    url: "/jjyl/WebCustomer/info/findCustomerServicePgdStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  customerDownload: function (params) {
    url: "/jjyl/WebCustomer/info/download";
    params = params || {};
    return Http.excelPost(url, params);
  },
  customerTemplatedownload: function (params) {
    url: "/jjyl/WebCustomer/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },

  customerImportExcel: function (params) {
    url: "/jjyl/WebCustomer/info/importExcel";
    params = params || {};
    return Http.listPost(url, params);
  },
  addCustomer: function (params) {
    url: "/jjyl/WebCustomer/info/addCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },
  uploadCustomerPic: function (params) {
    url: "/jjyl/WebCustomer/info/uploadCustomerPic";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServiceStation: function (params) {
    url: "/jjyl/WebServestation/info/findServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertServeStation: function (params) {
    url: "/jjyl/WebServestation/info/insertServeStation";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServeStation: function (params) {
    url: "/jjyl/WebServestation/info/updateServeStation";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServeStation: function (params) {
    url: "/jjyl/WebServestation/info/deleteServeStation";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/findServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServeGroup: function (params) {
    url: "/jjyl/ServeGroup/info/findServeGroupList";
    params = params || {};
    return Http.listPost(url, params);
  },
  getVolunteer: function (params) {
    url: "/jjyl/VolunteerController/info/findVolunteer";
    params = params || {};
    return Http.listPost(url, params);
  },
  addVolunteer: function (params) {
    url: "/jjyl/VolunteerController/info/insertVolunteer";
    params = params || {};
    return Http.listPost(url, params);
  },
  findVolunteerId: function (params) {
    url: "/jjyl/VolunteerController/info/findVolunteerByID";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCustomersId: function (params) {
    url: "/jjyl/WebCustomer/info/getCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/updateCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },
  checkCustomersBeforeDel: function (params) {
    url: "/jjyl/WebCustomer/info/checkCustomersBeforeDel";
    params = params || {};
    return Http.listPost(url, params);
  },
  checkBeforeBatchDelete: function (params) {
    url: "/jjyl/WebCustomer/info/checkBeforeBatchDelete";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/deleteCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },

  recallCustomers: function (params) {
    url: "/jjyl/WebCustomer/info/recallCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },

  //话务小结统计详情
  callSummaryAgentDetail: function(params) {
    return Http.listPost('jjyl/callInfo/info/callSummaryAgentDetail',params);
  },

  findVolunteer: function (params) {
    url: "/jjyl/VolunteerController/info/findVolunteer";
    params = params || {};
    return Http.listPost(url, params);
  },
  uploadCustomers: function (params) {
    url: "/jjyl/webCustomerExcel/info/upload";
    params = params || {};
    return Http.formDataPost(url, params);
  },
  downloadCustomers: function (params) {
    url: "/jjyl/webCustomerExcel/info/download";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServicePGD: function (params) {
    url: "/jjyl/servicePgd/info/findServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  servicePgdTemplatedownload: function (params) {
    url: "/jjyl/servicePgd/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  findServicePgdStarStatistics: function (params) {
    url: "/jjyl/servicePgd/info/findServicePgdStarStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  addServicePGD: function (params) {
    url: "/jjyl/servicePgd/info/addServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  finalServicepgd: function (params) {
    url: "/jjyl/servicePgd/info/finalServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeType: function (params) {
    url: "/jjyl/admin/type/info/findList";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSecondServeType: function (params) {
    url: "/jjyl/WebServeType/info/findSecondServeType";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeTypeById: function (params) {
    url: "/jjyl/WebServeType/info/findServeTypeById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertServeType: function (params) {
    url: "/jjyl/WebServeType/info/insertServeType";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServeType: function (params) {
    url: "/jjyl/WebServeType/info/updateServeType";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServeType: function (params) {
    url: "/jjyl/WebServeType/info/deleteServeType";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServeProduct: function (params) {
    url: "/jjyl/WebserveProdcut/info/findServeProduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServeProductId: function (params) {
    url: "/jjyl/WebserveProdcut/info/findServeProductById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeProductStatisc: function (params) {
    url: "/jjyl/WebserveProdcut/info/findServeProductStatisc";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeProductStatiscNumbers: function (params) {
    url: "/jjyl/WebserveProdcut/info/findServeProductStatiscNumbers";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServicePgdId: function (params) {
    url: "/jjyl/servicePgd/info/findServicepgdById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeStation: function (params) {
    url: "/jjyl/WebServestation/info/findServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServestationById: function (params) {
    url: "/jjyl/WebServestation/info/findServestationById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServePersonByServestationId: function (params) {
    url: "/jjyl/WebServestation/info/findServePersonByServestationId";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServepersonId: function (params) {
    url: "/jjyl/WebServeperson/info/getServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServePersonIds: function (params) {
    url: "/jjyl/WebServeperson/info/findServePersonIds";
    params = params || {};
    return Http.listPost(url, params);
  },

  updateServicePGD: function (params) {
    url: "/jjyl/servicePgd/info/updateServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },

  paifaOrder: function (params) {
    url: "/jjyl/servicePgd/info/Distribute";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAndDistribute: function (params) {
    url: "/jjyl/servicePgd/info/insertAndDistribute";
    params = params || {};
    return Http.listPost(url, params);
  },
  Invalid: function (params) {
    url: "/jjyl/servicePgd/info/Invalid";
    params = params || {};
    return Http.listPost(url, params);
  },
  zuofeiOrder: function (params) {
    url: "/jjyl/servicePgd/info/End";
    params = params || {};
    return Http.listPost(url, params);
  },
  chuliOrder: function (params) {
    url: "/jjyl/servicePgd/info/Handle";
    params = params || {};
    return Http.listPost(url, params);
  },
  chehuiOrder: function (params) {
    url: "/jjyl/servicePgd/info/withdraw";
    params = params || {};
    return Http.listPost(url, params);
  },
  huifangOrder: function (params) {
    url: "/jjyl/servicePgd/info/Visit";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/deleteServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/findServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  getServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/getServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertServeGroup: function (params) {
    url: "/jjyl/ServeGroup/info/insertServeGroup";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServeGroupById: function (params) {
    url: "/jjyl/ServeGroup/info/findServeGroupById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServeGroup: function (params) {
    url: "/jjyl/ServeGroup/info/updateServeGroup";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServeGroup: function (params) {
    url: "/jjyl/ServeGroup/info/deleteServeGroup";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteVolunteer: function (params) {
    url: "/jjyl/VolunteerController/info/deleteVolunteer";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAddressById: function (params) {
    url: "/jjyl/address/info/findAddressById";
    params = params || {};
    return Http.listPost(url, params);
  },
  bind: function (params) {
    url: "/jjyl/WebCustomer/info/bind";
    params = params || {};
    console.log(params,'params')
    return Http.listPost(url, params);
  },
  getShengAndShiAddress: function (params) {
    url: "/jjyl/address/info/getShengAndShiAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertServePerson: function (params) {
    url: "/jjyl/WebServeperson/info/insertServePerson";
    params = params || {};
    return Http.listPost(url, params);
  },
  nameUniqueCheck: function (params) {
    url: "/jjyl/WebServeperson/info/nameUniqueCheck";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/updateServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/deleteServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },

  findUserById: function (params) {
    url: "/jjyl/syuser/info/findUserById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAddresses: function (params) {
    url: "/jjyl/address/info/findAddresses";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAddress: function (params) {
    url: "/jjyl/address/info/findAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  getAddress: function (params) {
    url: "/jjyl/address/info/getAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAddress: function (params) {
    url: "/jjyl/address/info/insertAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAddress: function (params) {
    url: "/jjyl/address/info/updateAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteAddress: function (params) {
    url: "/jjyl/address/info/deleteAddress";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateStopStates: function (params) {
    url: "/jjyl/address/info/updateStopStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateStartStates: function (params) {
    url: "/jjyl/address/info/updateStartStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCustomerAddressNumbers: function (params) {
    url: "/jjyl/address/info/findCustomerAddressNumbers";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCustomerAddressList: function (params) {
    url: "/jjyl/address/info/findCustomerAddressQuList";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertServeProduct: function (params) {
    url: "/jjyl/WebserveProdcut/info/insertServeProduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServeProduct: function (params) {
    url: "/jjyl/WebserveProdcut/info/updateServeProduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteServeProduct: function (params) {
    url: "/jjyl/WebserveProdcut/info/deleteServeProduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateQianyue: function (params) {
    url: "/jjyl/WebCustomer/info/updateQianyue";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateZhuxiao: function (params) {
    url: "/jjyl/WebCustomer/info/updateZhuxiao";
    params = params || {};
    return Http.listPost(url, params);
  },
  login: function (params) {
    url: "/jjyl/sys/auth/login";
    params = params || {};
    return Http.listPost(url, params);
  },
  loginOut: function (params) {
    url: "/jjyl/sys/auth/logout";
    params = params || {};
    return Http.get(url, params);
  },
  findServicePgdStatistics: function (params) {
    url: "/jjyl/servicePgd/info/findServicePgdStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  downloadServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/downloadServicePgd";
    params = params || {};
    return Http.excelPost(url, params);
  },
  findVisitPgdStatistics: function (params) {
    url: "/jjyl/servicePgd/info/findVisitPgdStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  downloadVisitServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/downloadVisitServicePgd";
    params = params || {};
    return Http.excelPost(url, params);
  },
  downloadServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/download";
    params = params || {};
    return Http.excelPost(url, params);
  },
  startServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/start";
    params = params || {};
    return Http.listPost(url, params);
  },
  overServicePgd: function (params) {
    url: "/jjyl/servicePgd/info/over";
    params = params || {};
    return Http.listPost(url, params);
  },
  findUser: function (params) {
    url: "/jjyl/user/info/findUser";
    params = params || {};
    return Http.listPost(url, params);
  },
  findUserById: function (params) {
    url: "/jjyl/user/info/findUserById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateUser: function (params) {
    url: "/jjyl/user/info/updateUser";
    params = params || {};
    return Http.listPost(url, params);
  },
  //修改密码
  updatePassword: function (params) {
    url: "/jjyl/user/info/updatePassword";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertUser: function (params) {
    url: "/jjyl/user/info/insertUser";
    params = params || {};
    return Http.listPost(url, params);
  },
  delectUser: function (params) {
    url: "/jjyl/user/info/delectUser";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertRole: function (params) {
    url: "/jjyl/role/info/insertRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateRole: function (params) {
    url: "/jjyl/role/info/updateRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  findRole: function (params) {
    url: "/jjyl/role/info/findRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  findRoleById: function (params) {
    url: "/jjyl/role/info/findRoleById";
    params = params || {};
    return Http.listPost(url, params);
  },
  delectRole: function (params) {
    url: "/jjyl/role/info/delectRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertMenu: function (params) {
    url: "/jjyl/menu/info/insertMenu";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateMenu: function (params) {
    url: "/jjyl/menu/info/updateMenu";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenuOrg: function (params) {
    url: "/jjyl/orgmenu/info/findMenuOrg";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateMenuOrg: function (params) {
    url: "/jjyl/orgmenu/info/updateMenuOrg";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenu: function (params) {
    url: "/jjyl/menu/info/findMenu";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenuTree: function (params) {
    url: "/jjyl/menu/info/findMenuTree";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenuById: function (params) {
    url: "/jjyl/menu/info/findMenuById";
    params = params || {};
    return Http.listPost(url, params);
  },
  delectMenu: function (params) {
    url: "/jjyl/menu/info/delectMenu";
    params = params || {};
    return Http.listPost(url, params);
  },
  findRole: function (params) {
    url: "/jjyl/role/info/findRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  findUserRole: function (params) {
    url: "/jjyl/user/role/findUserRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateUserRole: function (params) {
    url: "/jjyl/user/role/updateUserRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCityInfo: function (params) {
    url: "/jjyl/cityinfo/info/findCityInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertCityInfo: function (params) {
    url: "/jjyl/cityinfo/info/insertCityInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCityInfoById: function (params) {
    url: "/jjyl/cityinfo/info/findCityInfoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateCityInfo: function (params) {
    url: "/jjyl/cityinfo/info/updateCityInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenuRole: function (params) {
    url: "/jjyl/menu/role/findMenuRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateMenuRole: function (params) {
    url: "/jjyl/menu/role/updateMenuRole";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMenu: function (params) {
    url: "/jjyl/menu/info/findMenu";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteCityInfo: function (params) {
    url: "/jjyl/cityinfo/info/deleteCityInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  StopServestation: function (params) {
    url: "/jjyl/WebServestation/info/StopServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  stopServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/stopServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  startServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/startServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  startServestation: function (params) {
    url: "/jjyl/WebServestation/info/startServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServePersonStarStatistics: function (params) {
    url: "/jjyl/WebServeperson/info/findServePersonStarStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCityInfoById: function (params) {
    url: "/jjyl/cityinfo/info/findCityInfoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSkill: function (params) {
    url: "/jjyl/WebServeperson/info/findSkill";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateSkill: function (params) {
    url: "/jjyl/WebServeperson/info/updateSkill";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServetypeServestation: function (params) {
    url: "/jjyl/WebServestation/info/findServetypeServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateServetypeServestation: function (params) {
    url: "/jjyl/WebServestation/info/updateServetypeServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAddressServestation: function (params) {
    url: "/jjyl/WebServestation/info/findAddressServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  saveAddressServestation: function (params) {
    url: "/jjyl/WebServestation/info/saveAddressServestation";
    params = params || {};
    return Http.listPost(url, params);
  },
  AddressTreelist: function (params) {
    url: "/jjyl/address/info/AddressTreelist";
    params = params || {};
    return Http.listPost(url, params);
  },
  ServetypeTreelist: function (params) {
    url: "/jjyl/WebServeType/info/ServetypeTreelist";
    params = params || {};
    return Http.listPost(url, params);
  },
  ServetypeServepersonTreelist: function (params) {
    url: "/jjyl/WebServeType/info/ServetypeServepersonTreelist";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAgent: function (params) {
    url: "/jjyl/agent/info/findAgent";
    params = params || {};
    return Http.listPost(url, params);
  },
  getCustomerByPhone: function (params) {
    url: "/jjyl/WebCustomer/info/getCustomerByPhone";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAdviceType: function (params) {
    url: "/jjyl/adviceType/info/findAdviceType";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAdvicepgd: function (params) {
    url: "/jjyl/advicepgd/info/insertAdvicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAdvicepgd: function (params) {
    url: "/jjyl/advicepgd/info/findAdvicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAdvicePgdStatistics: function (params) {
    url: "/jjyl/advicepgd/info/findAdvicePgdStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  download: function (params) {
    url: "/jjyl/advicepgd/info/download";
    params = params || {};
    return Http.excelPost(url, params);
  },
  downloadInformation: function (params) {
    url: "/jjyl/advicepgd/info/downloadInformation";
    params = params || {};
    return Http.excelPost(url, params);
  },
  findReturnPgd: function (params) {
    url: "/jjyl/returnPgd/info/findReturnPgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findRecFileInfo: function (params) {
    url: "/jjyl/recFile/info/findRecFileInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCallhistory: function (params) {
    let url = "jjyl/callInfo/info/findCallhistory";
    params = params || {};
    return Http.listPost(url, params);
  },
  //通话记录
  findCallrecord: function (params) {
    let url = "jjyl/callInfo/info/findCallrecord";
    params = params || {};
    return Http.listPost(url, params);
  },
  findReturnTree: function (params) {
    url: "/jjyl/return/info/findReturnTree";
    params = params || {};
    return Http.listPost(url, params);
  }, callsummaryByID: function (params) {
    let url = "jjyl/callInfo/info/callsummaryByID";
    params = params || {};
    return Http.listPost(url, params);
  },
  callsummarySave: function (params) {
    let url = "jjyl/callInfo/info/callsummarySave";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAdvicepgdById: function (params) {
    url: "/jjyl/advicepgd/info/findAdvicepgdById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAdvicepgd: function (params) {
    url: "/jjyl/advicepgd/info/updateAdvicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteAdvicepgd: function (params) {
    url: "/jjyl/advicepgd/info/deleteAdvicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAgentById: function (params) {
    url: "/jjyl/agent/info/findAgentById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAgentByAgentExt: function (params) {
    url: "/jjyl/agent/info/findAgentByAgentExt";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAgent: function (params) {
    url: "/jjyl/agent/info/insertAgent";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAgent: function (params) {
    url: "/jjyl/agent/info/updateAgent";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteAgent: function (params) {
    url: "/jjyl/agent/info/deleteAgent";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAdviceType: function (params) {
    url: "/jjyl/adviceType/info/insertAdviceType";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAdviceTypeById: function (params) {
    url: "/jjyl/adviceType/info/findAdviceTypeById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAdviceType: function (params) {
    url: "/jjyl/adviceType/info/updateAdviceType";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteAdviceType: function (params) {
    url: "/jjyl/adviceType/info/deleteAdviceType";
    params = params || {};
    return Http.listPost(url, params);
  },
  findGovernment: function (params) {
    url: "/jjyl/government/info/findGovernment";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteGovernment: function (params) {
    url: "/jjyl/government/info/deleteGovernment";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateGovernment: function (params) {
    url: "/jjyl/government/info/updateGovernment";
    params = params || {};
    return Http.listPost(url, params);
  },
  findGovernmentById: function (params) {
    url: "/jjyl/government/info/findGovernmentById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertGovernment: function (params) {
    url: "/jjyl/government/info/insertGovernment";
    params = params || {};
    return Http.listPost(url, params);
  },
  findServepersonPoint: function (params) {
    url: "/jjyl/WebServeperson/info/findServepersonPoint";
    params = params || {};
    return Http.listPost(url, params);
  },
  // findRecFileInfo: function (params) {
  //   url: "/jjyl/recFile/info/findRecFileInfo";
  //   params = params || {};
  //   return Http.listPost(url, params);
  // },
  findRecFileInfoById: function (params) {
    url: "/jjyl/recFile/info/findRecFileInfoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  dwonloadRecFileInfoById: function (params) {
    url: "/jjyl/recFile/info/dwonloadRecFileInfoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCallInfo: function (params) {
    let url = "jjyl/callInfo/info/findCallInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  huruDownload: function (params) {
    let url = "jjyl/callInfo/info/download";
    params = params || {};
    return Http.excelPost(url, params);
  },
  huchuDownload: function (params) {
    let url = "jjyl/callInfo/info/downloads";
    params = params || {};
    return Http.excelPost(url, params);
  },

  callHistoryDownload: function (params) {
    let url = "jjyl/callInfo/info/callhistorydownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  ServicePgdExcels: function (params) {
    url: "/jjyl/servicePgd/info/ServicePgdExcel";
    params = params || {};
    return Http.listPost(url, params);
  },
  findIvrCallInfo: function (params) {
    url: "/jjyl/ivrCallInfo/info/findIvrCallInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  getInTimeInfo: function (params) {
    url: "/jjyl/ivrCallInfo/info/getInTimeInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCommonsms: function (params) {
    url: "/jjyl/commonsms/info/findCommonsms";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertCommonsms: function (params) {
    url: "/jjyl/commonsms/info/insertCommonsms";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateCommonsms: function (params) {
    url: "/jjyl/commonsms/info/updateCommonsms";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteCommonsms: function (params) {
    url: "/jjyl/commonsms/info/deleteCommonsms";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCommonsmsId: function (params) {
    url: "/jjyl/commonsms/info/findCommonsmsId";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSms: function (params) {
    url: "/jjyl/sms/info/findSms";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertSms: function (params) {
    url: "/jjyl/sms/info/insertSms";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSmsShen: function (params) {
    url: "/jjyl/smsShen/info/findSmsShen";
    params = params || {};
    return Http.listPost(url, params);
  },
  smsShenHe: function (params) {
    url: "/jjyl/smsShen/info/smsShenHe";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertAddressSms: function (params) {
    url: "/jjyl/sms/info/insertAddressSms";
    params = params || {};
    return Http.listPost(url, params);
  },
  findChildren: function (params) {
    url: "/jjyl/children/info/findChildren";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertChildren: function (params) {
    url: "/jjyl/children/info/insertChildren";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateChildren: function (params) {
    url: "/jjyl/children/info/updateChildren";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteChildren: function (params) {
    url: "/jjyl/children/info/deleteChildren";
    params = params || {};
    return Http.listPost(url, params);
  },
  findChildrenById: function (params) {
    url: "/jjyl/children/info/findChildrenById";
    params = params || {};
    return Http.listPost(url, params);
  },
  //话务监管
  hwFindCallInfo: function (params) {
    let url = "jjyl/callInfo/info/findCallInfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务对象批量签约
  batchUpdateQianyue: function (params) {
    url: "/jjyl/WebCustomer/info/batchUpdateQianyue";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务对象批量注销
  batchUpdateZhuxiao: function (params) {
    url: "/jjyl/WebCustomer/info/batchUpdateZhuxiao";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务对象批量删除
  batchdeleteCustomer: function (params) {
    url: "/jjyl/WebCustomer/info/batchdeleteCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务对象批量审核
  batchUpdateShenhe: function (params) {
    url: "/jjyl/WebCustomer/info/batchUpdateShenhe";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务对象审核
  updateShenhe: function (params) {
    url: "/jjyl/WebCustomer/info/updateShenhe";
    params = params || {};
    return Http.listPost(url, params);
  },
  //工单批量处理
  batchHandle: function (params) {
    url: "/jjyl/servicePgd/info/batchHandle";
    params = params || {};
    return Http.listPost(url, params);
  },
  //工单批量回访
  batchReturnVisit: function (params) {
    url: "/jjyl/servicePgd/info/batchReturnVisit";
    params = params || {};
    return Http.listPost(url, params);
  },
  //工单批量作废
  batchToVoid: function (params) {
    url: "/jjyl/servicePgd/info/batchToVoid";
    params = params || {};
    return Http.listPost(url, params);
  },
  //工单批量撤回
  batchWithdraw: function (params) {
    url: "/jjyl/servicePgd/info/batchWithdraw";
    params = params || {};
    return Http.listPost(url, params);
  },
  //工单批量删除
  batchDeleteServicepgd: function (params) {
    url: "/jjyl/servicePgd/info/batchDeleteServicepgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  //二次派发
  secondDistribute: function (params) {
    url: "/jjyl/servicePgd/info/secondDistribute";
    params = params || {};
    return Http.listPost(url, params);
  },
  //异常工单二次派发
  abnormalSecondDistribute: function (params) {
    url: "/jjyl/servicePgd/info/abnormalSecondDistribute";
    params = params || {};
    return Http.listPost(url, params);
  },
  //三次派发
  thirdDistribute: function (params) {
    url: "/jjyl/servicePgd/info/thirdDistribute";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCoordinate: function (params) {
    url: "/jjyl/Coordinate/info/findCoordinate";
    params = params || {};
    return Http.listPost(url, params);
  },
  findLiveHome: function (params) {
    url: "/jjyl/livehome/info/findLiveHome";
    params = params || {};
    return Http.listPost(url, params);
  },
  findLiveHomeById: function (params) {
    url: "/jjyl/livehome/info/findLiveHomeById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertLiveHome: function (params) {
    url: "/jjyl/livehome/info/insertLiveHome";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateLiveHome: function (params) {
    url: "/jjyl/livehome/info/updateLiveHome";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteLiveHome: function (params) {
    url: "/jjyl/livehome/info/deleteLiveHome";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMapLiveHome: function (params) {
    url: "/jjyl/livehome/info/findMapLiveHome";
    params = params || {};
    return Http.listPost(url, params);
  },
  findInstitutions: function (params) {
    url: "/jjyl/institutions/info/findInstitutions";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertInstitutions: function (params) {
    url: "/jjyl/institutions/info/insertInstitutions";
    params = params || {};
    return Http.listPost(url, params);
  },
  findInstitutionsById: function (params) {
    url: "/jjyl/institutions/info/findInstitutionsById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateInstitutions: function (params) {
    url: "/jjyl/institutions/info/updateInstitutions";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteInstitutions: function (params) {
    url: "/jjyl/institutions/info/deleteInstitutions";
    params = params || {};
    return Http.listPost(url, params);
  },
  Templatedownload: function (params) {
    url: "/jjyl/institutions/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  importExcel: function (params) {
    url: "/jjyl/institutions/info/importExcel";
    params = params || {};
    return Http.excelPost(url, params);
  },
  livehomeTemplatedownload: function (params) {
    url: "/jjyl/livehome/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  livehomeImportExcel: function (params) {
    url: "/jjyl/livehome/info/importExcel";
    params = params || {};
    return Http.excelPost(url, params);
  },
  childrenTemplatedownload: function (params) {
    url: "/jjyl/children/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  childrenImportExcel: function (params) {
    url: "/jjyl/children/info/importExcel";
    params = params || {};
    return Http.excelPost(url, params);
  },
  findServePersonPgdStatistics: function (params) {
    url: "/jjyl/WebServeperson/info/findServePersonPgdStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCommunitys: function (params) {
    url: "/jjyl/communitys/info/findCommunitys";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertCommunitys: function (params) {
    url: "/jjyl/communitys/info/insertCommunitys";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCommunitysById: function (params) {
    url: "/jjyl/communitys/info/findCommunitysById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateCommunitys: function (params) {
    url: "/jjyl/communitys/info/updateCommunitys";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteCommunitys: function (params) {
    url: "/jjyl/communitys/info/deleteCommunitys";
    params = params || {};
    return Http.listPost(url, params);
  },
  communitysTemplatedownload: function (params) {
    url: "/jjyl/communitys/info/Templatedownload";
    params = params || {};
    return Http.excelPost(url, params);
  },
  communitysImportExcel: function (params) {
    url: "/jjyl/communitys/info/importExcel";
    params = params || {};
    return Http.excelPost(url, params);
  },
  queryPayOrder: function (params) {
    url: "/jjyl/servicePgd/info/queryPayOrder";
    params = params || {};
    return Http.listPost(url, params);
  },
  getPoint: function (params) {
    url: "/jjyl/point/info/findPoint";
    params = params || {};
    return Http.listPost(url, params);
  },
  getFranchiser: function (params) {
    url: "/jjyl/FranchiserController/info/findFranchiser";
    params = params || {};
    return Http.listPost(url, params);
  },
  addFranchiser: function (params) {
    url: "/jjyl/FranchiserController/info/insertFranchiser";
    params = params || {};
    return Http.listPost(url, params);
  },
  findFranchiserId: function (params) {
    url: "/jjyl/FranchiserController/info/findFranchiserByID";
    params = params || {};
    return Http.listPost(url, params);
  },
  findFranchiseenumber: function (params) {
    url: "/jjyl/FranchiserController/info/findFranchiseenumber";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateFranchiser: function (params) {
    url: "/jjyl/FranchiserController/info/updateFranchiser";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteFranchiser: function (params) {
    url: "/jjyl/FranchiserController/info/deleteFranchiser";
    params = params || {};
    return Http.listPost(url, params);
  },
  getBaseinfo: function (params) {
    url: "/jjyl/WebDatabaseController/info/findDatabase";
    params = params || {};
    return Http.listPost(url, params);
  },
  findDatabaseTree: function (params) {
    url: "/jjyl/WebDatabaseController/info/findDatabaseTree";
    params = params || {};
    return Http.listPost(url, params);
  },
  addBaseinfo: function (params) {
    url: "/jjyl/WebDatabaseController/info/insertDatabase";
    params = params || {};
    return Http.listPost(url, params);
  },
  findBaseinfoId: function (params) {
    url: "/jjyl/WebDatabaseController/info/findDatabaseById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateBaseinfo: function (params) {
    url: "/jjyl/WebDatabaseController/info/updateDatabase";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteBaseinfo: function (params) {
    url: "/jjyl/WebDatabaseController/info/deleteDatabase";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAppVersion: function (params) {
    url: "/jjyl/WebServeperson/info/updateAppVersion";
    params = params || {};
    return Http.listPost(url, params);
  },

  /*-- 初始配置项 --*/
  getInitConfig: () => {
    let url = VOLUNTEER_API + '/wechat/volunteer/initConfig'
    console.log("getInitConfig : " + url);
    return Http.jsonStrictGet(url)
  },
  getServiceTypeByPid: id => {
    let url = '/wechat/volunteer/getServiceTypeByPid'
    return Http.jsonStrictGet(url, { id })
  },
  getZoneByPid: id => {
    let url = '/wechat/volunteer/getZoneByPid'
    return Http.jsonStrictGet(url, { id })
  },
  getServiceTypeCredit: type => {
    let url = '/wechat/volunteer/getServiceTypeCredit'
    return Http.jsonStrictGet(url, { secondLevelTypeId: type })
  },
  /*-- 志愿者管理 --*/
  getVolunteerList: function (params) {
    let url = VOLUNTEER_API + '/volunteer/list'
    console.log("getVolunteerList : " + url);

    return Http.jsonStrictPost(url, params)
  },
  getVolunteerDetail: function (params) {
    let url = '/volunteer/detail'
    return Http.jsonStrictPost(url, params)
  },
  auditVolunteer: function (params) {
    let url = '/volunteer/audit'
    return Http.jsonStrictPost(url, params)
  },
  delVol: params => {
    let url = '/volunteer/delete'
    return Http.jsonStrictPost(url, params)
  },
  /*-- 工单管理 --*/
  // 增
  createTicket: params => {
    let url = '/volunteer/ticket/add'
    return Http.jsonStrictPost(url, params)
  },
  // 修改
  updateTicket: params => {
    let url = '/volunteer/ticket/update'
    return Http.jsonStrictPost(url, params)
  },
  // 改 - 指派工单
  ticketAssgin: params => {
    let url = '/volunteer/ticket/assgin'
    return Http.jsonStrictPost(url, params)
  },
  // 查
  getTicketList: params => {
    let url = VOLUNTEER_API + `/volunteer/ticket/list`
    console.log("getTicketList : " + url);

    return Http.jsonStrictPost(url, params, {
      pageNo: params.pageNo,
      pageSize: params.pageSize
    })
  },
  // 详情
  getTicketDetail: params => {
    let url = `/volunteer/ticket/detail`
    return Http.jsonStrictPost(url, params)
  },
  // 删除
  delTicket: params => {
    let url = '/volunteer/ticket/delete'
    return Http.jsonStrictPost(url, params)
  },
  // 评价
  commentTask: params => {
    let url = '/volunteer/ticket/comment'
    return Http.jsonStrictPost(url, params)
  },

  /*-- 礼品管理 --*/
  // 增
  addGift: params => {
    let url = '/volunteer/gift/add'
    return Http.jsonStrictPost(url, params)
  },
  editGift: params => {
    let url = '/volunteer/gift/update'
    return Http.jsonStrictPost(url, params)
  },
  // 查
  getGiftList: params => {
    let url = VOLUNTEER_API + '/volunteer/gift/list'
    console.log("getGiftList : " + url);

    return Http.jsonStrictPost(url, params, {
      pageNo: params.pageNo,
      pageSize: params.pageSize
    })
  },
  // 删
  delGift: params => {
    let url = '/volunteer/gift/delete'
    return Http.jsonStrictPost(url, params)
  },
  // 改
  changeGiftStatus: params => {
    let url = '/volunteer/gift/publish'
    return Http.jsonStrictPost(url, params)
  },
  /* 服务对象管理 */
  getClientList: params => {
    let url = VOLUNTEER_API + `/volunteer/ticket/queryServPerson`
    console.log("getClientList : " + url);

    return Http.jsonStrictPost(url, params, {
      pageNo: params.pageNo,
      pageSize: params.pageSize
    })
  },

  /*-- 订单管理 --*/
  // 删
  // 改
  // 查
  getOrderList: params => {
    let url = VOLUNTEER_API + '/volunteer/order/list'
    console.log("getOrderList : " + url);

    return Http.jsonStrictPost(url, params)
  },
  orderDeploy: params => {
    let url = '/volunteer/order/deploy'
    return Http.jsonStrictPost(url, params)
  },
  orderCancel: params => {
    let url = '/volunteer/order/cancel'
    return Http.jsonStrictPost(url, params)
  },

  /*-- 统计 --*/
  volunteerStatistics: params => {
    let url = '/volunteer/statistic'
    return Http.jsonStrictPost(url, params)
  },

  findSyorganizationById: function (params) {
    url: "/jjyl/organization/info/findSyorganizationById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAllSyorganization: function (params) {
    url: "/jjyl/organization/info/findAllSyorganization";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSyorganization: function (params) {
    url: "/jjyl/organization/info/findSyorganization";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertSyorganization: function (params) {
    url: "/jjyl/organization/info/insertSyorganization";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateSyorganization: function (params) {
    url: "/jjyl/organization/info/updateSyorganization";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteSyorganization: function (params) {
    url: "/jjyl/organization/info/deleteSyorganization";
    params = params || {};
    return Http.listPost(url, params);
  },
  findHelpinfoById: function (params) {
    url: "/jjyl/helpinfo/info/findHelpinfoById";
    params = params || {};
    return Http.listPost(url, params);
  },

  findHelpinfo: function (params) {
    url: "/jjyl/helpinfo/info/findHelpinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertHelpinfo: function (params) {
    url: "/jjyl/helpinfo/info/insertHelpinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteHelpinfo: function (params) {
    url: "/jjyl/helpinfo/info/deleteHelpinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateHelpinfo: function (params) {
    url: "/jjyl/helpinfo/info/updateHelpinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findPhoneinfo: function (params) {
    url: "/jjyl/phoneinfo/info/findPhoneinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findPhoneinfoById: function (params) {
    url: "/jjyl/phoneinfo/info/findPhoneinfoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertPhoneinfo: function (params) {
    url: "/jjyl/phoneinfo/info/insertPhoneinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  updatePhoneinfo: function (params) {
    url: "/jjyl/phoneinfo/info/updatePhoneinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  deletePhoneinfo: function (params) {
    url: "/jjyl/phoneinfo/info/deletePhoneinfo";
    params = params || {};
    return Http.listPost(url, params);
  },
  findPhone2info: function (params) {
    url: "/jjyl/phone2info/info/findPhone2info";
    params = params || {};
    return Http.listPost(url, params);
  },
  findPhone2infoById: function (params) {
    url: "/jjyl/phone2info/info/findPhone2infoById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertPhone2info: function (params) {
    url: "/jjyl/phone2info/info/insertPhone2info";
    params = params || {};
    return Http.listPost(url, params);
  },
  updatePhone2info: function (params) {
    url: "/jjyl/phone2info/info/updatePhone2info";
    params = params || {};
    return Http.listPost(url, params);
  },
  deletePhone2info: function (params) {
    url: "/jjyl/phone2info/info/deletePhone2info";
    params = params || {};
    return Http.listPost(url, params);
  },
  findReturn: function (params) {
    url: "/jjyl/return/info/findReturn";
    params = params || {};
    return Http.listPost(url, params);
  },
  findReturnById: function (params) {
    url: "/jjyl/return/info/findReturnById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertReturn: function (params) {
    url: "/jjyl/return/info/insertReturn";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateReturn: function (params) {
    url: "/jjyl/return/info/updateReturn";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteReturn: function (params) {
    url: "/jjyl/return/info/deleteReturn";
    params = params || {};
    return Http.listPost(url, params);

  },
  SyorganizationTreelist: function (params) {
    url: "/jjyl/orgmenu/info/SyorganizationTreelist";
    params = params || {};
    return Http.listPost(url, params);
  },
  getQuestionbank: function (params) {
    url: "/jjyl/QuestionbankController/info/findQuestionbank";
    params = params || {};
    return Http.listPost(url, params);
  },
  addQuestionbank: function (params) {
    url: "/jjyl/QuestionbankController/info/insertQuestionbank";
    params = params || {};
    return Http.listPost(url, params);
  },
  findQuestionbankId: function (params) {
    url: "/jjyl/QuestionbankController/info/findQuestionById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateQuestionbank: function (params) {
    url: "/jjyl/QuestionbankController/info/updateQuestionbank";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteQuestionbank: function (params) {
    url: "/jjyl/QuestionbankController/info/deleteQuestionbank";
    params = params || {};
    return Http.listPost(url, params);
  },

  //查询服务工单总数和当月服务工单数
  findServicePgdCnt: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdCnt";
    params = params || {};
    return Http.listPost(url, params);
  },
  //用户名
  getUserName: function (params) {
    url: "/jjyl/DataAnalysisController/info/getUserName";
    params = params || {};
    return Http.listPost(url, params);
  },

  //历年服务人员
  findServepersonYear: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonYear";
    params = params || {};
    return Http.listPost(url, params);
  },

  //用户增长
  findCustomerYear: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerYear";
    params = params || {};
    return Http.listPost(url, params);
  },
  //查询按类型区分工单数量
  findServicepgdType: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdTypes";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务人员按地区
  findServepersonAddress: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonAddress";
    params = params || {};
    return Http.listPost(url, params);
  },

  //一周服务工单 按地区
  findServicePgdWeekName: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdWeekName";
    params = params || {};
    return Http.listPost(url, params);
  },

  //一周服务工单
  findServicePgdWeek: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdWeek";
    params = params || {};
    return Http.listPost(url, params);
  },

  //星级评价
  findServicePgdLevel: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdLevel";
    params = params || {};
    return Http.listPost(url, params);
  },

  //工单时效性
  findServicePgdHours: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdHours";
    params = params || {};
    return Http.listPost(url, params);
  },

  //本月服务工单
  findServicePgdMonth: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdMonth";
    params = params || {};
    return Http.listPost(url, params);
  },

  //服务老人区域分布
  findCustomerCity: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerCity";
    params = params || {};
    return Http.listPost(url, params);
  },

  //服务老人分类
  findCustomerTypes: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerTypeCity";
    params = params || {};
    return Http.listPost(url, params);
  },

  //服务老人状态
  findCustomerStatus: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerStatus";
    params = params || {};
    return Http.listPost(url, params);
  },

  //服务老人年龄分布
  findCustomerAge: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerAge";
    params = params || {};
    return Http.listPost(url, params);
  },

  //服务老人居住状态分布
  findCustomerLiveType: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerLiveType";
    params = params || {};
    return Http.listPost(url, params);
  },

  //老年人生活区域 性别区分 婚姻状况 总人数
  findCustomerLiveAreas: function (params) {
    url: "/jjyl/DataAnalysisController/info/findCustomerLiveAreas";
    params = params || {};
    return Http.listPost(url, params);
  },

  //兴康阿姨性别比
  findServepersonPerson: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonPerson";
    params = params || {};
    return Http.listPost(url, params);
  },
  //志愿者性别比
  findServepersonPersonV: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonPersonV";
    params = params || {};
    return Http.listPost(url, params);
  },
  //志愿者近一年增涨
  findVolunteerYear: function (params) {
    url: "/jjyl/DataAnalysisController/info/findVolunteerYear";
    params = params || {};
    return Http.listPost(url, params);
  },
  //兴康阿姨和志愿者按地区分布
  findServepersonPersonAndVell: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonPersonAndVell";
    params = params || {};
    return Http.listPost(url, params);
  },
  findVolunteerQuName: function (params) {
    url: "/jjyl/DataAnalysisController/info/findVolunteerQuName";
    params = params || {};
    return Http.listPost(url, params);
  },
  //查询服务工单本周按类型区分工单
  findServicePgdWeekType: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdWeekType";
    params = params || {};
    return Http.listPost(url, params);
  },

  //本月新增工单排名
  findServicePgdMonthCity: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdMonthCity";
    params = params || {};
    return Http.listPost(url, params);
  },

  //本周政府援助和商业工单
  findServicePgdWeekPgdtype: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServicePgdWeekPgdtype";
    params = params || {};
    return Http.listPost(url, params);
  },

  //咨询工单
  findAdvicepgdType: function (params) {
    url: "/jjyl/DataAnalysisController/info/findAdvicepgdType";
    params = params || {};
    return Http.listPost(url, params);
  },

  //用户增长
  findServepersonCustomer: function (params) {
    url: "/jjyl/DataAnalysisController/info/findServepersonCustomer";
    params = params || {};
    return Http.listPost(url, params);
  },

  //体检记录查询
  // findMedicalExaminationReport: function (params) {
  //   url: "/jjyl/medical/info/findMedicalExaminationReport";
  //   params = params || {};
  //   return Http.listPost(url, params);
  // },
  //体检记录查询
  findCustomerMedicalExaminationReport: function (params) {
    url: "/jjyl/medical/info/findCustomerMedicalExaminationReport";
    params = params || {};
    return Http.listPost(url, params);
  },

  //app
  getallaoodata: function (params) {
    url: "/jjyl/changeContent/info/findChangeContent";
    params = params || {};
    return Http.listPost(url, params);
  },
  addallaoodata: function (params) {
    url: "/jjyl/changeContent/info/insertChangeContent";
    params = params || {};
    return Http.listPost(url, params);
  },
  removeallaoodata: function (params) {
    url: "/jjyl/changeContent/info/updateChangeContent";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteallaoodata: function (params) {
    url: "/jjyl/changeContent/info/deleteChangeContent";
    params = params || {};
    return Http.listPost(url, params);
  },



  //体检记录查询 单查
  findMedicalExaminationReportId: function (params) {
    url: "/jjyl/WebElderlyInformation/info/findElderlyInformation";
    params = params || {};
    return Http.listPost(url, params);
  },

  getCustomersByPhone: function (params) {
    url: "/jjyl/WebCustomer/info/checkPhone";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  getCustomersByIdnumber: function (params) {
    url: "/jjyl/WebCustomer/info/checkIdNumber";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  getCustomersByIdCard: function (params) {
    url: "/jjyl/children/info/checkIdCard";
    //url: "/jjyl/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  customerTemplatedownloads: function (params) {
    url: "/jjyl/WebCustomer/info/Templatedownloads";
    params = params || {};
    return Http.excelPost(url, params);
  },
  customerImportExcels: function (params) {
    url: "/jjyl/WebCustomer/info/importExcels";
    params = params || {};
    return Http.listPost(url, params);
  },
  customerDownloads: function (params) {
    url: "/jjyl/WebCustomer/info/downloads";
    params = params || {};
    return Http.excelPost(url, params);
  },
  findPolicyRules: function (params) {
    url: "/jjyl/policyRules/info/findPolicyRules";
    params = params || {};
    return Http.listPost(url, params);
  },

  findPolicyRulesById: function (params) {
    url: "/jjyl/policyRules/info/findPolicyRulesById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertPolicyRules: function (params) {
    url: "/jjyl/policyRules/info/insertPolicyRules";
    params = params || {};
    return Http.listPost(url, params);
  },

  updatePolicyRules: function (params) {
    url: "/jjyl/policyRules/info/updatePolicyRules";
    params = params || {};
    return Http.listPost(url, params);
  },

  deletePolicyRules: function (params) {
    url: "/jjyl/policyRules/info/deletePolicyRules";
    params = params || {};
    return Http.listPost(url, params);
  },

  releasePolicyRules: function (params) {
    url: "/jjyl/policyRules/info/releasePolicyRules";
    params = params || {};
    return Http.listPost(url, params);
  },

  findIndustrynews: function (params) {
    url: "/jjyl/industrynews/info/findIndustrynews";
    params = params || {};
    return Http.listPost(url, params);
  },

  findIndustrynewsById: function (params) {
    url: "/jjyl/industrynews/info/findIndustrynewsById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertIndustrynews: function (params) {
    url: "/jjyl/industrynews/info/insertIndustrynews";
    params = params || {};
    return Http.listPost(url, params);
  },

  updateIndustrynews: function (params) {
    url: "/jjyl/industrynews/info/updateIndustrynews";
    params = params || {};
    return Http.listPost(url, params);
  },

  deleteIndustrynews: function (params) {
    url: "/jjyl/industrynews/info/deleteIndustrynews";
    params = params || {};
    return Http.listPost(url, params);
  },
  relaseIndustrynews: function (params) {
    url: "/jjyl/industrynews/info/relaseIndustrynews";
    params = params || {};
    return Http.listPost(url, params);
  },
  findHealthproject: function (params) {
    url: "/jjyl/healthproject/info/findHealthproject";
    params = params || {};
    return Http.listPost(url, params);
  },

  findHealthprojectById: function (params) {
    url: "/jjyl/healthproject/info/findHealthprojectById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertHealthproject: function (params) {
    url: "/jjyl/healthproject/info/insertHealthproject";
    params = params || {};
    return Http.listPost(url, params);
  },

  updateHealthproject: function (params) {
    url: "/jjyl/healthproject/info/updateHealthproject";
    params = params || {};
    return Http.listPost(url, params);
  },

  deleteHealthproject: function (params) {
    url: "/jjyl/healthproject/info/deleteHealthproject";
    params = params || {};
    return Http.listPost(url, params);
  },
  relaseHealthproject: function (params) {
    url: "/jjyl/healthproject/info/relaseHealthproject";
    params = params || {};
    return Http.listPost(url, params);
  },
  findHealthmanage: function (params) {
    url: "/jjyl/healthmanage/info/findHealthmanage";
    params = params || {};
    return Http.listPost(url, params);
  },

  findHealthmanageById: function (params) {
    url: "/jjyl/healthmanage/info/findHealthmanageById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertHealthmanage: function (params) {
    url: "/jjyl/healthmanage/info/insertHealthmanage";
    params = params || {};
    return Http.listPost(url, params);
  },

  updateHealthmanage: function (params) {
    url: "/jjyl/healthmanage/info/updateHealthmanage";
    params = params || {};
    return Http.listPost(url, params);
  },

  deleteHealthmanage: function (params) {
    url: "/jjyl/healthmanage/info/deleteHealthmanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  relaseHealthmanage: function (params) {
    url: "/jjyl/healthmanage/info/relaseHealthmanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  findHealthproduct: function (params) {
    url: "/jjyl/healthproduct/info/findHealthproduct";
    params = params || {};
    return Http.listPost(url, params);
  },

  findHealthproductById: function (params) {
    url: "/jjyl/healthproduct/info/findHealthproductById";
    params = params || {};
    return Http.listPost(url, params);
  },

  insertHealthproduct: function (params) {
    url: "/jjyl/healthproduct/info/insertHealthproduct";
    params = params || {};
    return Http.listPost(url, params);
  },

  updateHealthproduct: function (params) {
    url: "/jjyl/healthproduct/info/updateHealthproduct";
    params = params || {};
    return Http.listPost(url, params);
  },

  deleteHealthproduct: function (params) {
    url: "/jjyl/healthproduct/info/deleteHealthproduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  relaseHealthproduct: function (params) {
    url: "/jjyl/healthproduct/info/relaseHealthproduct";
    params = params || {};
    return Http.listPost(url, params);
  },
  findEnterprise: function (params) {
    url: "/jjyl/enterprise/info/findEnterprise";
    params = params || {};
    return Http.listPost(url, params);
  },
  findEnterpriseById: function (params) {
    url: "/jjyl/enterprise/info/findEnterpriseById";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertEnterprise: function (params) {
    url: "/jjyl/enterprise/info/insertEnterprise";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateEnterprise: function (params) {
    url: "/jjyl/enterprise/info/updateEnterprise";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteEnterprise: function (params) {
    url: "/jjyl/enterprise/info/deleteEnterprise";
    params = params || {};
    return Http.listPost(url, params);
  },
  relaseEnterprise: function (params) {
    url: "/jjyl/enterprise/info/relaseEnterprise";
    params = params || {};
    return Http.listPost(url, params);
  },
  /*-- 紧急救援人员管理 --*/
  findEmergencyPersonnel: function (params) {
    url: "/jjyl/emergencyPersonnel/info/findEmergencyPersonnel";
    params = params || {};
    return Http.listPost(url, params);
  },
  findEmergencyPersonnelById: function (params) {
    url: "/jjyl/emergencyPersonnel/info/findEmergencyPersonnelById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateEmergencyPersonnel: function (params) {
    url: "/jjyl/emergencyPersonnel/info/updateEmergencyPersonnel";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertEmergencyPersonnel: function (params) {
    url: "/jjyl/emergencyPersonnel/info/insertEmergencyPersonnel";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteEmergencyPersonnel: function (params) {
    url: "/jjyl/emergencyPersonnel/info/deleteEmergencyPersonnel";
    params = params || {};
    return Http.listPost(url, params);
  },
  /*-- 合同信息管理 --*/
  findContract: function (params) {
    url: "/jjyl/WebContract/info/findContract";
    params = params || {};
    return Http.listPost(url, params);
  },
  findContractById: function (params) {
    url: "/jjyl/WebContract/info/findContractById";
    params = params || {};
    return Http.listPost(url, params);
  },
  addContract: function (params) {
    url: "/jjyl/WebContract/info/insertContract";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateContract: function (params) {
    url: "/jjyl/WebContract/info/updateContract";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteContract: function (params) {
    url: "/jjyl/WebContract/info/deleteContract";
    params = params || {};
    return Http.listPost(url, params);
  },
  downloadContract: function (params) {
    url: "/jjyl/WebContract/info/download";
    params = params || {};
    return Http.excelPost(url, params);
  },

  /*-- 修改坐席状态 --*/
  updateAgentTypes: function (params) {
    url: "/jjyl/agent/info/updateAgentTypes";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAgentXianStates: function (params) {
    url: "/jjyl/agent/info/updateAgentXianStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateAgentMangStates: function (params) {
    url: "/jjyl/agent/info/updateAgentMangStates";
    params = params || {};
    return Http.listPost(url, params);
  },
  /*-- 作废理由管理 --*/
  getabolitionReason: function (params) {
    url: "/jjyl/reason/info/findReason";
    params = params || {};
    return Http.listPost(url, params);
  },
  addabolitionReason: function (params) {
    url: "/jjyl/reason/info/insertReason";
    params = params || {};
    return Http.listPost(url, params);
  },
  rmeabolitionReason: function (params) {
    url: "/jjyl/reason/info/updateReason";
    params = params || {};
    return Http.listPost(url, params);
  },
  delabolitionReason: function (params) {
    url: "/jjyl/reason/info/deleteReason";
    params = params || {};
    return Http.listPost(url, params);
  },
  /*-- 服务人员管理修改服务区域 --*/
  findAddressServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/findAddressServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  saveAddressServeperson: function (params) {
    url: "/jjyl/WebServeperson/info/saveAddressServeperson";
    params = params || {};
    return Http.listPost(url, params);
  },
  findAddressAndType: function (params) {
    url: "/jjyl/address/info/findAddressAndType";
    params = params || {};
    return Http.listPost(url, params);
  },
  /**服务工单结算导出 */
  downloadServepgdstatic: function (params) {
    url: "/jjyl/servicePgd/info/downloadServepgdstatic";
    params = params || {};
    return Http.excelPost(url, params);
  },
  /**服务人员结算导出 */
  downloadServePersonStatistics: function (params) {
    url: "/jjyl/WebServeperson/info/downloadServepersonstatic";
    params = params || {};
    return Http.excelPost(url, params);
  },
  /**服务对象结算导出 */
  downloadCustomerStatistics: function (params) {
    url: "/jjyl/WebCustomer/info/downloadCustomerStatistics";
    params = params || {};
    return Http.excelPost(url, params);
  },
  //服务对象不通过审核
  updateShenhes: function (params) {
    url: "/jjyl/WebCustomer/info/updateShenhes";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 新增呼入呼出功能
  IncomingAndOutgoingStatistics: function (params) {
    let url = "jjyl/callInfo/info/findCallInfoStatics";
    //let url = "/employee/basic//basicdata";
    params = params || {};
    return Http.listPost(url, params);
  },
  //月底汇总
  findMothStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findMothStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  downloadMothStatistic: function (params) {
    url: "/jjyl/statisticalData/info/downloadMothStatistic";
    params = params || {};
    return Http.excelPost(url, params);
  },
  //未服务原因分析
  findNonserviceReason: function (params) {
    url: "/jjyl/statisticalData/info/findNonserviceReason";
    params = params || {};
    return Http.listPost(url, params);
  },
   //结算报表
   findCustomerSettlement: function (params) {
    url: "/jjyl/statisticalData/info/findCustomerSettlement";
    params = params || {};
    return Http.listPost(url, params);
  },
  //时间段内服务覆盖老人数与线下老人数占比
  findCustomerRatio: function (params) {
    url: "/jjyl/statisticalData/info/findCustomerRatio";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务率
  findServiceRateStatistics: function (params) {
    url: "/jjyl/statisticalData/info/findServiceRateStatistics";
    params = params || {};
    return Http.listPost(url, params);
  },
  //定时任务管理
  findTimingtask: function (params) {
    url: "/jjyl/sys/info/findTimingtask";
    params = params || {};
    return Http.listPost(url, params);
  },
  addinsertTimingtask: function (params) {
    url: "/jjyl/sys/info/save";
    params = params || {};
    return Http.listPost(url, params);
  },
  findScheduleById: function (params) {
    url: "/jjyl/sys/info/findScheduleById";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateTimingtask: function (params) {
    url: "/jjyl/sys/info/update";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteTimingtask: function (params) {
    url: "/jjyl/sys/info/delete";
    params = params || {};
    return Http.listPost(url, params);
  },
  taskFixed:function(params){
    url: "/jjyl/sys/info/run";
    params = params || {};
    return Http.listPost(url, params);
  },
  //服务工时异常规则
  findSingularRule: function (params) {
    url: "/jjyl/singularRule/info/findSingularRule";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertSingularRule: function (params) {
    url: "/jjyl/singularRule/info/insertSingularRule";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateSingularRule: function (params) {
    url: "/jjyl/singularRule/info/updateSingularRule";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteSingularRule: function (params) {
    url: "/jjyl/singularRule/info/deleteSingularRule";
    params = params || {};
    return Http.listPost(url, params);
  },
  findSingularRuleById: function (params) {
    url: "/jjyl/singularRule/info/findSingularRuleById";
    params = params || {};
    return Http.listPost(url, params);
  },
  //消息功能管理
  findMessagemanage: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertMessagemanage: function (params) {
    url: "/jjyl/messagemanage/info/insertMessagemanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateMessagemanage: function (params) {
    url: "/jjyl/messagemanage/info/updateMessagemanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteMessagemanage: function (params) {
    url: "/jjyl/messagemanage/info/deleteMessagemanage";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMessagemanageById: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanageById";
    params = params || {};
    return Http.listPost(url, params);
  },
  findMessagemanageCount: function (params) {
    url: "/jjyl/messagemanage/info/findMessagemanageCount";
    params = params || {};
    return Http.listPost(url, params);
  },
  // 重置密码
  resetPassword: function (params) {
    url: "/jjyl/user/info/resetPassword";
    params = params || {};
    return Http.listPost(url, params);
  },
  //公益活动管理
  findCommonweal: function (params) {
    url: "/jjyl/commonweal/info/findCommonweal";
    params = params || {};
    return Http.listPost(url, params);
  },
  insertCommonweal: function (params) {
    url: "/jjyl/commonweal/info/insertCommonweal";
    params = params || {};
    return Http.listPost(url, params);
  },
  updateCommonweal: function (params) {
    url: "/jjyl/commonweal/info/updateCommonweal";
    params = params || {};
    return Http.listPost(url, params);
  },
  deleteCommonweal: function (params) {
    url: "/jjyl/commonweal/info/deleteCommonweal";
    params = params || {};
    return Http.listPost(url, params);
  },
  findCommonwealById: function (params) {
    url: "/jjyl/commonweal/info/findCommonwealById";
    params = params || {};
    return Http.listPost(url, params);
  },
  //异常工单
  updateAbnormalHandlePgd: function (params) {
    url: "/jjyl/servicePgd/info/updateAbnormalHandlePgd";
    params = params || {};
    return Http.listPost(url, params);
  },
  //外呼覆盖率
  findCallCoverag: function (params) {
    url: "/jjyl/statisticalData/info/findCallCoverag";
    params = params || {};
    return Http.listPost(url, params);
  },
  //未服务原因分析
  findNonserviceReason: function (params) {
    url: "/jjyl/statisticalData/info/findNonserviceReason";
    params = params || {};
    return Http.listPost(url, params);
  },
}
/*
   [ 登录请求 ]
*/
const metaLoginDao = {
  requestLogin: function (params) {
    url: "/jjyl/sys/auth/login";
    params = params || {};
    return Http.listPost(url, params);
  },

}

/*
   [ 元数据管理模块 元数据创建 ]
*/

const metaDataCreateDao = {
  // 列表数据获取
  getList: function (params) {
    url: "/jjyl/metadata/list";
    params = params || {};
    return Http.post(url, params);
  },
  //组织结构树数据获取
  getTreeData: function (params) {
    url: "/jjyl/metadata/getDataSourceTree";
    params = params || {};
    return Http.post(url, params);
  }
}



/*
   [ 元数据管理模块  元模型管理 ]
*/

const metaModelDao = {
  // 列表数据获取
  getList: function (params) {
    url: "/jjyl/sysMgr/metaModel/list";
    params = params || {};
    return Http.post(url, params);
  },
  getDropDownList: function (params) {
    url: "/jjyl/common/getDropDownList";
    params = params || {};
    params.dropDownListType = 'SYS_DICT'
    params.code = 'metamodel_status';
    return Http.post(url, params);
  },
  add: function (params) {
    url: "/jjyl/sysMgr/metaModel/add";
    params = params || {};
    return Http.post(url, params);
  },
  update: function (params) {
    url: "/jjyl/sysMgr/metaModel/update";
    params = params || {};
    return Http.post(url, params);
  },
  delete: function (params) {
    url: "/jjyl/sysMgr/metaModel/delete";
    params = params || {};
    return Http.post(url, params);
  },
  sort: function (params) {
    url: "/jjyl/sysMgr/metaModel/sort";
    params = params || {};
    return Http.post(url, params);
  },

}



/*
   [ 元数据管理模块  元模型管理 详情 ]
*/

const metaModelDetailDao = {
  // 列表数据获取
  getList: function (params) {
    url: "/jjyl/sysMgr/metaModelDetail/list";
    params = params || {};
    return Http.post(url, params);
  },
  getDropDownList: function (params) {
    console.log(params);
    url: "/jjyl/common/getDropDownList";
    params = params || {};
    params.dropDownListType = 'SYS_DICT'
    params.code = 'metamodel_status';
    return Http.post(url, params);
  },
  add: function (params) {
    url: "/jjyl/sysMgr/metaModelDetail/add";
    params = params || {};
    return Http.post(url, params);
  },
  update: function (params) {
    url: "/jjyl/sysMgr/metaModelDetail/update";
    params = params || {};
    return Http.post(url, params);
  },
  delete: function (params) {
    url: "/jjyl/sysMgr/metaModelDetail/delete";
    params = params || {};
    return Http.post(url, params);
  },
  sort: function (params) {
    url: "/jjyl/sysMgr/metaModelDetail/sort";
    params = params || {};
    return Http.post(url, params);
  }
}
export { dataSourceMgr, metaDataMgrDao, metaDataCreateDao, metaModelDao, metaModelDetailDao, metaLoginDao }
